import { css } from 'lit';
/**
 * Base theme styles with CSS custom properties.
 * Import into components: static styles = [krBaseCSS, css`...`]
 */
export const krBaseCSS = css `
  :host,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host {
    /* Primary */
    --kr-primary: rgb(22, 48, 82);
    --kr-primary-hover: rgb(16, 36, 62);
    --kr-primary-text: #ffffff;

    /* Accent */
    --kr-accent: #BEEA4E;
    --kr-accent-hover: #a8d43a;
    --kr-accent-text: #000000;

    /* Text */
    --kr-text: #000000;
    --kr-text-muted: #4b5563;
    --kr-text-disabled: #9ca3af;
      
    /* Borders */
    --kr-border: #e5e7eb;
  }
`;
//# sourceMappingURL=base.js.map